import { watchOpenStore, useStore } from '../../store/uiStore'
import { IS_TOUCH } from '../../config/touch'

// ============================================================
// Richiamo dell'orologio per i dispositivi touch: sul telefono non
// esiste il tasto Q, e senza questo pulsante il quadrante non si
// alzerebbe mai — portandosi dietro ricerca, comandi e carrello, che
// ormai vivono solo lì sopra.
// Il quadrante vero non è più DOM: è una superficie 3D disegnata su
// texture (OrologioFaccia), figlia del nodo WatchScreen del modello.
// ============================================================
export default function OrologioSchermo() {
  const aperto = useStore(watchOpenStore)
  if (!IS_TOUCH) return null
  return (
    <button
      className={aperto ? 'orologio-tasto attivo' : 'orologio-tasto'}
      onClick={() => watchOpenStore.set(!aperto)}
      aria-label={aperto ? 'Abbassa il polso' : "Guarda l'orologio"}
    >
      ⌚
    </button>
  )
}
